<template>
  <div>
    <div id="myCanvasContainer">
    <canvas width="500" height="500" id="myCanvas" style="width: 75%"/>
    </div>
    <div id="tags">
    <ul id="icons">
        <li>
            <a href="https://docs.microsoft.com/en-us/dotnet/csharp/">
                <img :src="require('@/assets/Icons/csharp.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/CSS3">
                <img :src="require('@/assets/Icons/css3.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://getbootstrap.com/">
                <img :src="require('@/assets/Icons/bootstrap.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://git-scm.com/">
                <img :src="require('@/assets/Icons/git.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5">
                <img :src="require('@/assets/Icons/html5.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript">
                <img :src="require('@/assets/Icons/javascript.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://jquery.com/">
                <img :src="require('@/assets/Icons/jquery.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://www.meteor.com/">
                <img :src="require('@/assets/Icons/meteor.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://www.mongodb.com/">
                <img :src="require('@/assets/Icons/mongoDb.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://nodejs.org/en/">
                <img :src="require('@/assets/Icons/nodejs.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://www.python.org/">
                <img :src="require('@/assets/Icons/python.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://reactjs.org/">
                <img :src="require('@/assets/Icons/react.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://vuejs.org/">
                <img :src="require('@/assets/Icons/vuejs.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://webpack.js.org/">
                <img :src="require('@/assets/Icons/webpack.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://angular.io/">
                <img :src="require('@/assets/Icons/angular.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://kafka.apache.org/">
                <img :src="require('@/assets/Icons/kafka.svg')" class="tag-image"/>
            </a>
        </li>
            <li>
            <a href="https://cucumber.io/">
                <img :src="require('@/assets/Icons/cucumber.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://www.docker.com/">
                <img :src="require('@/assets/Icons/docker.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://gradle.org/">
                <img :src="require('@/assets/Icons/gradle.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://www.java.com/en/">
                <img :src="require('@/assets/Icons/java.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://www.oracle.com/database/technologies/appdev/sql.html">
                <img :src="require('@/assets/Icons/oracle.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://spring.io/">
                <img :src="require('@/assets/Icons/spring.svg')" class="tag-image"/>
            </a>
        </li>
        <li>
            <a href="https://www.typescriptlang.org/">
                <img :src="require('@/assets/Icons/typescript.svg')" class="tag-image"/>
            </a>
        </li>
    </ul>
    </div>
  </div>
</template>
<style scoped>
  #tags{
    position: absolute;
    display: inline;
    right: 9999px;
  }
  .tag-image {
    height:1px;
    width:1px;
  }
</style>
<script>
export default {
  name: 'Tag Canvas',
  mounted () {
    try {
      TagCanvas.Start('myCanvas', 'tags', options) // eslint-disable-line no-undef
    } catch (e) {
      // something went wrong, hide the canvas container
      document.getElementById('myCanvasContainer').style.display = 'none'
    }
  }
}
var options = {
  textColour: '#fff',
  textHeight: 20,
  depth: 1.5,
  outlineThickness: 0.5,
  outlineColour: '#fe0853',
  maxSpeed: 0.06,
  dragControl: true,
  freezeActive: true,
  shuffleTags: true,
  shape: 'sphere',
  zoom: 0.8,
  noSelect: true,
  textFont: null,
  wheelZoom: false,
  freezeDecel: true,
  imageScale: null,
  initial: [0.3, -0.1]
}

</script>



// WEBPACK FOOTER //
// src/components/TagCanvas.vue